import { lazy } from 'react'
import { filterppOptions } from './widget-options'

export const filterppDescription = {
  name: 'Filter++',
  component: lazy(async () => {
    const imported = await import('./FilterPlusPlusWidget' )
    return { default: imported.FilterPlusPlusWidget }
  }),
  label: 'Filter++',
  variables: filterppOptions,
}
